export default {"src":"/_next/static/media/star.855d7387.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};